import React, { lazy, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Header from 'src/components/Header/Header'
import { logOutOkta } from 'src/data-store/actions/auth'
import ls from 'local-storage'

const AccessDenied = lazy(() => import('../pages/AccessDenied/AccessDenied'))

const isDeniedAccess = (userRoles) => {
  var isDenied = true
  if (userRoles) {
    isDenied = !userRoles.toLowerCase().includes('fulfillmentapp')
  }
  return isDenied
}

const isTokenExpired = (expiration) => {
  const tokenExpiration = new Date(expiration * 1000) // need to * 1000 otherwise it will be 1970
  const now = new Date() // current date time

  return now >= tokenExpiration // will return true if the date time now is ahead of expiration token
}

const PrivateRoute = ({ isAllowed = true, children = {} }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn)
  const currentUser = useSelector((state) => state.auth.currentUser)
  const lostPermissions = isDeniedAccess(currentUser?.roles_string)
  var dispatch = useDispatch()

  useEffect(() => {
    if (currentUser.exp && isTokenExpired(currentUser.exp)) {
      if (ls('token')) { // need this otherwise it goes through the logout another time while the local storage is empty
        dispatch(logOutOkta())
      }
    }
  }, [])

  return (
    <>
      {isLoggedIn && isAllowed
        ? children
        : (
          lostPermissions ? ( // user has no permissions in the app due to being logged out
            <Navigate to='/logged-out' />
          )
            : (
              <>
                <Header />
                <AccessDenied />
              </>
            )
        )}
    </>
  )
}

export default PrivateRoute
